const RenderType = {
  INPUT: 0, // 正在编辑
  SHOW: 1, // 非编辑
};

const STEPTYPE = {
  BASEINFO: 1,
  GUARDIAN: 2,
  CERTIFICATE_PHOTO: 2,
  TRADING_PURPOSES: 3,
};

const TRANSFER_FROM = {
  ASSET: 6,
  SPOT: 1,
};

const EVENT_EMITTER_KEYS = {
  enterDialog: 'ENTER_DIALOG',
};

export { RenderType, STEPTYPE, TRANSFER_FROM, EVENT_EMITTER_KEYS };
